export interface IActionType {
    value: number,
    code: string,
    name: string,
    hasDeadline: boolean,
    needsDate: boolean,
    mode: string,
    service: string,
    displayOrder: number,
    highlight: boolean,
    hideOption: boolean
}